@if (simulation) {
  <pr-panel>
    <!-- Changer le label en input -->
    <pr-panel-header title="{{ simulationPackService.template.tableTitle }}">
      @if (canEdit) {
        <pr-button display="neutral" [label]="label" (onClick)="triggerForm()">
        </pr-button>
      }
    </pr-panel-header>
    <pr-panel-body>
      <pr-table [tableData]="tableData" [swiperMinWidth]="0">
        <!-- Table Header -->
        <!-- Empty Template -->
        <h4 class="semi-bold" emptyTemplate>
          {{ simulationPackService.template.tableEmptyText }}
        </h4>
      </pr-table>
      @if (simulation.result && edited) {
        <pr-color-panel display="success" clazz="mbn">
          <pr-panel-body clazz="pas">
            <pr-label name="check" [width]="18" [height]="18">{{
              simulationPackService.template.tableAdjusmentText
            }}</pr-label>
          </pr-panel-body>
        </pr-color-panel>
      }
    </pr-panel-body>
  </pr-panel>
}
